// extracted by mini-css-extract-plugin
module.exports = {"news-item-box":"A","newsItemBox":"A","img-box":"B","imgBox":"B","img-mask-box":"C","imgMaskBox":"C"};